export const SET_ERROR_CODE = 'SET_ERROR_CODE';
export const CLEAR_ERROR_CODE = 'CLEAR_ERROR_CODE';

export const setErrorCode = (code: number | null) => ({
  type: SET_ERROR_CODE,
  payload: code,
});

export const clearErrorCode = () => ({
  type: CLEAR_ERROR_CODE,
});
